<template>
    <div style="position: relative">
        <!--数据统计图-->
        <li class="circle-data" @click="lookRemindText">
            <div class="data">{{num}}</div>
            <div class="label">{{text}}
                <!--<Icon type="md-help-circle" class="remind-icon"/>-->
            </div>
            <div class="info">
                <span class="info-text">{{remindText}}</span>
                <div class="nav nav-background"></div>
            </div>
        </li>
    </div>
</template>

<script>
    export default {
        name: "data-statis-summary",
        props: ['num', 'text', 'remindText'],
        data() {
            return {}
        },
        methods: {
            /**
             * 查看提示文字
             */
            lookRemindText() {
                // this.$Modal.info({
                //     title: "提示",
                //     content: "<p style='font-size:16px;margin-top: -6px;'>"+this.remindText+"</p>",
                //     onOk: () => {
                //     }
                // })
            }
        }
    }
</script>

<style scoped lang="scss">
    @import "../style/detailPage";

    .circle-data {
        cursor: pointer;
        background: url("../assets/images/databoard/detailPage/green-circle.png") top no-repeat;
    }

    .label {
        position: relative;
    }

    .remind-icon {
        /*color: #00caaf;*/
        color: #FAC16B;
        position: absolute;
        top: -7px;
        right: 16px;
    }

    .info {
        display: none;
    }

    .circle-data:hover .info {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 50px;
        background: #00caaf;
        box-shadow: 1px 2px 3px #00caaf;
        border-radius: 4px;
        text-align: center;
        color: #fff;
        position: absolute;
        bottom: -58px;
        padding: 0 10px;
        z-index: 9999;
    }

    .nav {
        position: absolute;
        left: 30px;
        overflow: hidden;
        width: 0;
        height: 0;
        border-width: 10px;
        border-style: solid dashed dashed dashed;
    }

    .nav-background {
        top: -19px;
        border-color: transparent transparent #00caaf transparent;
    }
</style>
